import React from 'react'
import ContactComponent from '../Components/ContactComponent'
import Layout from '../Components/Layout/Layout'

const Contact = () => {
  return (
    <>
    <Layout>
        <ContactComponent />
    </Layout>
    </>
  )
}

export default Contact